module.exports = __webpack_public_path__ + "static/beet-burgers-4.705d74d6.jpg";